"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BorderlessButton = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var react_router_dom_1 = require("react-router-dom");
var icon_1 = require("../icon");
exports.BorderlessButton = react_1.default.memo(function (props) {
    var icon = props.icon, children = props.children, rest = __rest(props, ["icon", "children"]);
    var iconArea = !icon ? null : (react_1.default.createElement(IconCell, null,
        react_1.default.createElement(icon_1.Icon, { icon: icon, size: 16 })));
    var labelArea = !children ? null : react_1.default.createElement(LabelCell, null, children);
    var body = (react_1.default.createElement(react_1.default.Fragment, null,
        iconArea,
        labelArea));
    if ("to" in rest) {
        return (react_1.default.createElement(BorderlessButtonCore, __assign({ as: react_router_dom_1.Link }, rest), body));
    }
    else if ("href" in rest) {
        return (react_1.default.createElement(BorderlessButtonCore, __assign({ as: "a" }, rest), body));
    }
    else {
        return react_1.default.createElement(BorderlessButtonCore, __assign({}, rest), body);
    }
});
var BorderlessButtonCore = styled_components_1.default.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background: transparent;\n  border: none;\n  display: flex;\n\n  height: 32px;\n  padding: 7px;\n\n  color: ", ";\n  font-size: 13px;\n  line-height: 16px;\n\n  &:hover {\n    color: ", ";\n    cursor: pointer;\n    & svg path {\n      fill: ", ";\n    }\n  }\n\n  &:disabled {\n    opacity: 0.3;\n  }\n\n  &:focus {\n    outline: 0;\n  }\n\n  &:active {\n    color: ", ";\n    & svg path {\n      fill: ", ";\n    }\n  }\n"], ["\n  background: transparent;\n  border: none;\n  display: flex;\n\n  height: 32px;\n  padding: 7px;\n\n  color: ", ";\n  font-size: 13px;\n  line-height: 16px;\n\n  &:hover {\n    color: ", ";\n    cursor: pointer;\n    & svg path {\n      fill: ", ";\n    }\n  }\n\n  &:disabled {\n    opacity: 0.3;\n  }\n\n  &:focus {\n    outline: 0;\n  }\n\n  &:active {\n    color: ", ";\n    & svg path {\n      fill: ", ";\n    }\n  }\n"])), function (props) { return props.theme.colors.tableGray1; }, function (props) { return props.theme.colors.tableBlack2; }, function (props) { return props.theme.colors.tableBlack2; }, function (props) { return props.theme.colors.tableGray1; }, function (props) { return props.theme.colors.tableGray1; });
var IconCell = styled_components_1.default.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  vertical-align: top;\n  flex: 0 0 16px;\n"], ["\n  vertical-align: top;\n  flex: 0 0 16px;\n"])));
var LabelCell = styled_components_1.default.span(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  vertical-align: top;\n  flex: 1 0 auto;\n  text-align: center;\n  margin-left: 4px;\n"], ["\n  vertical-align: top;\n  flex: 1 0 auto;\n  text-align: center;\n  margin-left: 4px;\n"])));
var templateObject_1, templateObject_2, templateObject_3;
